import classNames from 'classnames'

import styles from './Product.module.scss'

const Sizes = ({ options, activeSize, updateActiveSize }: any) => {
  const allOptions: any[] = options?.[0]?.values

  const renderSizes = allOptions?.map(({ name, quantity, product_option_value_id }: any) => (
    <div
      key={product_option_value_id}
      className={classNames(styles.info__sizes_item, {
        [styles.info__sizes_item_active]: activeSize === product_option_value_id,
      })}
      onClick={() => updateActiveSize(product_option_value_id)}
    >
      <p>{name}</p>
      <p>({quantity} шт.)</p>
    </div>
  ))

  return (
    <div>
      <div className={styles.info__sizessssss}>
        <div className={styles.info__sizes}>
          <p className={styles.info__sizes_title}>Розмір </p>

          <div className={styles.info__sizes_items}>{renderSizes}</div>
        </div>
      </div>
    </div>
  )
}

export default Sizes
